import { createContext } from 'react';

const role = localStorage.getItem('role');

export const roleContext = createContext(role);
